export default __webpack_public_path__ + "static/media/bg_home.13da9115.jpg";